import { render } from "./DashboardHomeNew.vue?vue&type=template&id=4c901d90"
import script from "./DashboardHomeNew.vue?vue&type=script&lang=js"
export * from "./DashboardHomeNew.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/upwork/kaz/mbsm-pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__